import { useNavigate } from "react-router-dom";
import AppRoutes from "../constants/routes/AppRoutes";
import { Button } from "@capacit-com/lara-law-shared-ui";
import PageContent from "./PageContent";

const AccessDeniedView = () => {
  const navigate = useNavigate();

  return (
    <PageContent title="Adgang nægtet" appSidebar={true}>
      <div className="flex items-center justify-center flex-col h-full">
        <p className="text-base font-semibold text-primary">403</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-5xl">
          Du har ikke adgang til denne resource
        </h1>
        <p className="mt-6 text-base leading-7">
          Beklager, du har ikke tilstrækkelige rettigheder til at se denne side.
        </p>
        <div className="w-fit mt-4">
          <Button onClick={() => navigate(AppRoutes.dashboard)}>
            Gå tilbage til dashboard
          </Button>
        </div>
      </div>
    </PageContent>
  );
};

export default AccessDeniedView;
